export default {
  type2s: {
    value: "type2s",
    label: "Type IIS Enzymes",
    isSpecialGroup: true
  },
  important: {
    value: "important",
    label: "Important",
    isSpecialGroup: true
  },
  single: {
    value: "single",
    label: "Single cutters",
    cutsThisManyTimes: 1
  },
  double: {
    value: "double",
    label: "Double cutters",
    cutsThisManyTimes: 2
  },
  triple: {
    value: "triple",
    label: "Triple cutters",
    cutsThisManyTimes: 3
  }
};
